import Spaces from '../components/templates/spaces';

export const SpacesContainer = () => {
  return <Spaces />;
};
